import styled from "styled-components";

export const SideSliderContainer = styled.div<{ maxWidth: string }>`
  position: absolute;
  top: 0px;
  transition: all 0.3s ease;
  width: ${(props) => props.maxWidth};
  height: 85vh;
  padding: ${(props) => props.maxWidth !== "0" && "2em 2em"};
  background-color: #fff;
  overflow-x: hidden;
  overflow-y: scroll;
  right: 0;
  z-index: 2;
  margin-top: 4.5em;
  transition-property: width;
  border-top: 0.5px solid rgba(55, 81, 255, 0.1);
  box-shadow: 0px 30px 30px rgba(55, 81, 255, 0.2);
  padding-bottom: 4em;
  &:focus {
    border: 0 !important;
    outline: none;
  }
  &:-webkit-scrollbar-thumb {
    width: 4px;
  }
`;
